"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBApiDetailsTableofDetails", {
  enumerable: true,
  get: function get() {
    return _SVBApiDetailsTableofDetails.default;
  }
});
var _SVBApiDetailsTableofDetails = _interopRequireDefault(require("./src/SVBApiDetailsTableofDetails"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }